import React, { Component } from 'react'
import { MDBContainer, MDBNavbar, MDBNavbarBrand, MDBNavbarNav, MDBNavbarToggler, MDBCollapse, MDBNavItem, MDBNavLink, MDBIcon } from 'mdbreact';

export default class WhatIs extends Component {
  render() {
    return (
        	<div class="container">
		<div class="row daily24_intro justify-content-center">
			<div class="col-auto col-sm-auto col-md-auto col-lg-auto col-xl-auto ">
				<img src="https://i.ibb.co/2qrdfZ1/slice44-3x.png" alt="slice44-3x" class="intro_phone" border="0"/>
			</div>
			<div class="col-12 col-sm-11 col-md-9 col-lg-6 col-xl-5 daily24_brief">
				<p class="brief_title">What is Daily24?</p>
				<p class="brief_content">We are interested in understanding whether the “when” and “how much” of peoples’ eating and sleeping is related to their weight and health. In this study, we are using the Daily24 app to gather this information from many people like you.</p>
			</div>
	    </div>
		<div class="row">
			<div class="col"></div>
			<div class="col-10 col-sm-9 col-md-8 col-lg-7 col-xl-6">
                <MDBNavLink class="nav-link" to="/timeline">
				   <a href="#" class="Bottom_button">
				   <p>Your Timeline as you work with Daily24</p>
				   </a>
                </MDBNavLink>
            </div>
			<div class="col"></div>
		</div>
	</div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/WhatIs.js